// extracted by mini-css-extract-plugin
export default {"button":"SquareButton_button__GoVDM","add":"SquareButton_add__2VF9c","remove":"SquareButton_remove__iT-J0"};